//////////////////////
// AWS Lambda input //
//////////////////////
import { VHost } from "./lib/kotenna/VHost";
import { CloudProvider } from "./lib/kotenna/CloudProvider";

export interface JsonRpcRequest {
    jsonrpc: string;
    method: string;
    id: string;
    params: {
        vhost?: VHost;
        provider?: CloudProvider;
        instanceId?: string
    };
}

export interface JsonRpcResponse {
    jsonrpc: string;
    id: string;
    result?: any;
    error?: any;

}